import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { documentTypes, userTypes } from './create-user-data';
import { updateUser } from '../../actions/user-actions';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getUser } from '../../actions/user-actions';
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";

function EditUser(){
    const currentLink = "/usuarios";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        documentType: '',
        document: '',
        email: '',
        professionalCard: '',
        userType: '',
        bankAccount: {
            bank: '',
            accountType: '',
            accountNumber: ''
        },
        password: '',
        repassword: '',
        signature: ''
    });

    const [imgData, setImgData] = useState({
        name: 'Seleccione un archivo..',
        value: '',
    });
    
    const[ showInfo, setShowInfo ] = useState(false);
    const[ fieldType, setFieldType ] = useState("password");

    useEffect(() => {
        if (loadData) {
            const getUserFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log(data.data);
                    const signature = data.data[0].signature;
                    if (signature && signature !== '') {
                        setImgData({
                            ...imgData,
                            value: signature
                        })
                    }
                    setForm({
                        ...form,
                        ...data.data[0]
                    })
                }
            }

            setLoadData(false);
            setForm({
                firstName: '',
                lastName: '',
                documentType: '',
                document: '',
                email: '',
                professionalCard: '',
                userType: '',
                bankAccount: {
                    bank: '',
                    accountType: '',
                    accountNumber: ''
                },
                password: '',
                repassword: '',
                signature: ''
            });
            dispatch( getUser( params.id, getUserFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, imgData, user.token ]);


    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleBankInputChange = (event) => {
        setForm({
            ...form,
            bankAccount: {
                ...form.bankAccount,
                [event.target.name] :  event.target.value
            }
        })
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (event.target.files.length === 0) {
            setImgData({
                name: 'Seleccione un archivo..',
                value: ''
            })

            setForm({
                ...form,
                signature: ''
            })
            return;
          }
      
        // Asignación y validación de formato del archivo subido, ya que solo se permiten imágenes
        let mimeType = file.type;
        if (mimeType.match(/image\/*/) == null) {
            alert("Solo se permiten imágenes");
            return;
        }
        const fileReader = new FileReader();
        let base64 = '';
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            const unencodedB64 = fileReader.result.split('base64,');
            base64 = unencodedB64[1];
            setImgData({
                name: file.name,
                value: base64
            })

            setForm({
                ...form,
                signature: base64
            })
            //console.log(base64)
        }
        fileReader.onerror = (error) => {
          console.log(error);
        }
    }

    const needShowInfo = () =>{
        if( fieldType === "password" ){
            setFieldType("text");
            setShowInfo(true);
        }
        else{
            setFieldType("password");
            setShowInfo(false);
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( field !== 'password' && field !== 'repassword' && form[field] === '') {
                    return true
                }
            }
        }
        return false
    }

    const validatePasswords = () => {
        if (form.password !== '') {
            if (form.password !== form.repassword) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
            return;
        } else {
            if (validatePasswords()) {
                let newObj = {
                    ...form
                };

                if (newObj.password === '') {
                    delete newObj.password;
                    delete newObj.repassword;
                }
                dispatch( updateUser( newObj, updateUserFunction, user.token ) );
            } else {
                Swal.fire({
                    title:"¡Atención!",
                    confirmButtonColor:"#76b4ff",
                    text:"Las contraseñas deben coincidir",
                });
                return;
            }
        }
    }

    const updateUserFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Usuario actualizado con éxito"
            });
        }
    }

    const Signature = ({ data }) => <img src={`data:image/jpeg;base64,${data}`} alt="userSignature" className="preview-signature" />

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Editar usuario</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <h4 className="w-100 mb-2">Datos generales</h4>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="firstName">Nombres</label>
                            <input id="firstName" name="firstName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.firstName}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="lastName">Apellidos</label>
                            <input id="lastName" name="lastName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.lastName}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="documentType">Tipo de documento</label>
                            <select className="input-field" id="documentType" name="documentType" onChange={handleInputChange} value={form.documentType}>
                                <option></option>
                                {documentTypes.map((documentType, index) => (
                                    <option key={index} value={documentType.value}>{documentType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="document">Documento</label>
                            <input id="document" name="document" autoComplete="off"  maxLength={15} className="input-field" type="number" onChange={handleInputChange} value={form.document}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="email">Email</label>
                            <input id="email" name="email" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange} value={form.email}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="professionalCard">Número de tarjeta profesional</label>
                            <input id="professionalCard" name="professionalCard" autoComplete="off" type="number" className="input-field" onChange={handleInputChange} value={form.professionalCard}></input>
                        </div>
                        <h4 className="w-100 my-2">Cuenta bancaria</h4>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="bank">Banco</label>
                            <input autoComplete="off" id="bank" name="bank" className="input-field"type="text" onChange={handleBankInputChange} value={form.bankAccount.bank}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="accountType">Tipo de cuenta</label>
                            <input autoComplete="off" id="accountType" name="accountType" className="input-field"type="text" onChange={handleBankInputChange} value={form.bankAccount.accountType}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="accountNumber">Número de cuenta bancaria</label>
                            <input autoComplete="off" id="accountNumber" name="accountNumber" className="input-field"type="text" onChange={handleBankInputChange} value={form.bankAccount.accountNumber}></input>
                        </div>
                        <h4 className="w-100 my-2">Administrador</h4>
                        <div className="d-flex flex-column w-50 field position-relative">
                            <label className="label-field" htmlFor="password">Nueva contraseña (Opcional)</label>
                            <input autoComplete="off" id="password" name="password" minLength={6} maxLength={10} className="input-field" onChange={handleInputChange} placeholder="Mínimo 6 caracteres" type={fieldType}></input>
                            { !showInfo ? 
                                <BsFillEyeFill onClick={needShowInfo} className='eye-icon' />
                            :
                                <BsFillEyeSlashFill onClick={needShowInfo} className='eye-icon' />
                            }
                        </div>
                        <div className="d-flex flex-column w-50 field position-relative">
                            <label className="label-field" htmlFor="repassword">Repetir contraseña</label>
                            <input autoComplete="off" id="repassword" name="repassword" minLength={6} maxLength={10} className="input-field" onChange={handleInputChange} placeholder="Mínimo 6 caracteres" type={fieldType}></input>
                            { !showInfo ? 
                                <BsFillEyeFill onClick={needShowInfo} className='eye-icon' />
                            :
                                <BsFillEyeSlashFill onClick={needShowInfo} className='eye-icon' />
                            }
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="userType">Tipo de usuario</label>
                            <select className="input-field" id="userType" name="userType" onChange={handleInputChange} value={form.userType}>
                                <option></option>
                                {userTypes.map((userType, index) => (
                                    <option key={index}>{userType}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="signature">Firma digital</label>
                            <label htmlFor="signature" className="file-upload">
                                {imgData.name}
                            </label>
                            <input id="signature" onChange={handleFileChange} accept="'image/*" type="file"/>
                        </div>
                        {form.signature !== '' ?
                            <div className="d-flex w-100 justify-content-center my-3">
                                <div className="d-flex flex-wrap" style={{width: 'min-content'}}>
                                    <h4 className="w-100 mb-2">Firma previa</h4>
                                    <Signature data={imgData.value} />
                                    <span className="w-100">{form.firstName.toUpperCase()} {form.lastName.toUpperCase()}</span>
                                    <span className="w-100">{form.documentType} No {form.document}</span>
                                </div>
                            </div>
                        :''}
                        <div className="w-100 d-flex d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditUser;
  